'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.maintenance = void 0;
var adapter_1 = require("../adapter");
var Maintenance = /** @class */ (function () {
    function Maintenance() {
    }
    /**
     * Filter maintenance
     */
    Maintenance.prototype.filter = function () {
        return adapter_1.adapter.maintenance.filter();
    };
    return Maintenance;
}());
exports.maintenance = new Maintenance();
